import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Attribute } from './attribute'

@Component({
  selector: 'app-attribute',
  templateUrl: './attribute.component.html',
  styleUrls: ['./attribute.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttributeComponent {

  @Input() parent: FormGroup
  @Input() attribute: Attribute
  @Input() width = '180px'

  get invalid() {
    const ctrl = this.parent.get(this.attribute.value)
    const required = ctrl.hasError('required') && ctrl.touched

    if (!this.attribute.isEmail) {
      return {required, email: null}
    }
    const email = ctrl.hasError('email') && ctrl.touched

    return {email, required}
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/attribute/attribute.component.ts